import { z } from "zod";
import { ReturnProductSchema } from "../draft-return/draft-return-items";
import { Provider } from "../order";
import { ShopifyGraphQLProductSchema as ProductDataSchema } from "../product";
import { AiReturnReasonSchema } from "./return-reasons";
export const ExchangeRecommendationsSchema = z.array(ProductDataSchema);

export const GenerateExchangeRecommendationsInputSchema = z.object({
  provider: z.enum(Provider),
  returnedProduct: ReturnProductSchema,
  reasons: z.array(AiReturnReasonSchema),
});

export type GenerateExchangeRecommendationsInput = z.infer<
  typeof GenerateExchangeRecommendationsInputSchema
>;

export type ExchangeRecommendations = z.infer<
  typeof ExchangeRecommendationsSchema
>;
